import * as React from 'react'

import { Carat, ExpansionPanel } from '@syconium/little-miss-figgy'

import { trackEvent } from '../../../../../../../lib/analytics'
import { textWithFilterCount } from '../../utils'

import {
  CaratIconWrapper,
  FilterInputDetails,
  FilterInputExpansionPanelWrapper,
  FilterInputLabel,
  FilterInputSummary,
  FilterInputSummaryWrapper,
} from './styles'

export const FilterInputSegment: React.FC<{
  isExpandedInitially?: boolean
  selectedFilterCount: number
  label: string
  children?: React.ReactNode
}> = ({ children, isExpandedInitially = false, label, selectedFilterCount }) => {
  return (
    <FilterInputExpansionPanelWrapper>
      <ExpansionPanel.Container defaultIsExpanded={isExpandedInitially}>
        <FilterInputSummaryWrapper>
          <ExpansionPanel.Summary
            expandIcon={isExpanded => (
              <CaratIconWrapper isRotated={isExpanded}>
                <Carat />
              </CaratIconWrapper>
            )}
          >
            <FilterInputSummary>
              <FilterInputLabel
                {...trackEvent({
                  category: 'reviews page',
                  action: 'filter category',
                  label,
                })}
              >
                {textWithFilterCount(label, selectedFilterCount)}
              </FilterInputLabel>
            </FilterInputSummary>
          </ExpansionPanel.Summary>
        </FilterInputSummaryWrapper>
        <ExpansionPanel.Details>
          <FilterInputDetails>{children}</FilterInputDetails>
        </ExpansionPanel.Details>
      </ExpansionPanel.Container>
    </FilterInputExpansionPanelWrapper>
  )
}
